function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOlivine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 631 707",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Olivine-Stone",
    x: 0.632,
    y: 0.983,
    width: 629.786,
    height: 705.351,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M234.705,20.693L91.365,156.409L27.606,371.419L124.913,585.881L241.015,683.704L425.142,680.91L594.58,396.421L567.132,182.967L429.892,20.693L234.705,20.693Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.365,156.409L235.908,320.491L27.606,371.419L91.365,156.409Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.705,20.693L235.908,320.491L91.365,156.409L234.705,20.693Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.892,20.693L241.015,683.643L234.705,20.693L429.892,20.693Z",
    style: {
      fill: "rgb(123,211,171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.006,586.802L235.908,320.491L27.606,371.419L126.006,586.802Z",
    style: {
      fill: "rgb(123,211,171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.132,182.967L425.142,680.91L594.58,396.421L567.132,182.967Z",
    style: {
      fill: "rgb(123,211,171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.892,20.693L498.646,423.14L567.132,182.967L429.892,20.693Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.006,586.802L237.558,320.491L241.015,683.704L126.006,586.802Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.015,683.704L425.142,680.91L499.77,419.199L429.892,20.693L241.015,683.704Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlivine);
export default __webpack_public_path__ + "static/media/olivine.242d12d97b34d3e2f70a2d0d49350d67.svg";
export { ForwardRef as ReactComponent };